import { createFileRoute, useNavigate } from '@tanstack/react-router'
import CourseCard from '@/components/CourseCard'
import { Space, Image } from 'antd-mobile'
// 定义路由
export const Route = createFileRoute('/favorites')({
  component: FavoritesPage,
})
import { SpaceStyle } from './order.index'
import useCourseObjList from '@/hook/useCourseList'
import SpinPending from '@/components/SpinPending'
import { useFavoriteList } from '@/hook/useFavoriteList'
import FavoriteService from '@/service/favoriteService'
import type { Favorite } from '@/types/info'
import { HeartOutline } from 'antd-mobile-icons'
import useRefresh from '@/hook/useRefresh'
import CourseService from '@/service/courseService'
// 定义收藏页面组件
function FavoritesPage(): JSX.Element {
  const navigate = useNavigate()
  const { isLoading: courseListIsLoading, refetch: refreshCourseList } =
    useCourseObjList()
  const { isLoading: favoriteListIsLoading, refetch: refreshFavoriteList } =
    useFavoriteList()
  useRefresh([refreshCourseList, refreshFavoriteList])
  const isLoading = courseListIsLoading || favoriteListIsLoading
  let favoriteList: Favorite[] | undefined = undefined
  if (!isLoading) {
    favoriteList = FavoriteService.filterInvalidCourse()
  }
  if (favoriteList !== undefined && favoriteList.length === 0) {
    return (
      <Space direction="vertical" block style={SpaceStyle}>
        <Image src="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"></Image>
        <h3 className="text-center text-[16px]">
          还没有收藏的课程呢，请到课程页面点击
          <HeartOutline style={{ display: 'inline' }} />
          收藏课程
        </h3>
      </Space>
    )
  }
  if (isLoading) {
    return (
      <Space direction="vertical" block style={SpaceStyle}>
        <SpinPending />
      </Space>
    )
  }
  return (
    <Space direction="vertical" block style={SpaceStyle}>
      {[...(favoriteList ?? [])].reverse().map((course) => {
        const courseObj = CourseService.getCourse(course.courseId)
        if (courseObj === undefined) {
          return null
        }
        return (
          <CourseCard
            key={course.courseId}
            course={courseObj}
            inventory={courseObj.region.reduce(
              (acc, cur) => acc + cur.hasInventory,
              0,
            )}
            onClick={() =>
              navigate({
                to: '/course/detail/$id',
                params: {
                  id: course.courseId.toString(),
                },
              })
            }
          />
        )
      })}
    </Space>
  )
}
